import { Suspense } from 'react';
import { createBrowserRouter, Outlet, RouterProvider } from 'react-router-dom';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';

import { useOnlineStatus } from '@leagueplatform/web-common';
import {
  FullPageError,
  LoadingIndicator,
  ErrorState,
} from '@leagueplatform/web-common-components';
import { LeagueProvider } from '@leagueplatform/core';
import { ObservabilityErrorBoundary } from '@leagueplatform/observability';

import { initMasonryRegistry } from 'utils/init-masonry-registry';
import { APP_MANAGED_ROUTES } from 'common/app-managed-routes';
import { config } from 'config';
import { appRoutes } from 'app-routes';

initMasonryRegistry();

const LeagueProviderWrapper = () => {
  const { isOffline, isOnline } = useOnlineStatus();
  return (
    <LeagueProvider config={config}>
      <ObservabilityErrorBoundary
        fallback={<ErrorState error={null} />}
        errorContext={{
          context: { Context: { location: 'Root App ErrorBoundary' } },
        }}
      >
        <Suspense fallback={<LoadingIndicator />}>
          {isOffline && (
            <FullPageError error={null} route={APP_MANAGED_ROUTES.HOME} />
          )}
          {isOnline && <Outlet />}
        </Suspense>
      </ObservabilityErrorBoundary>
      {import.meta.env.DEV && <ReactQueryDevtools initialIsOpen={false} />}
    </LeagueProvider>
  );
};

const router = createBrowserRouter([
  {
    element: <LeagueProviderWrapper />,
    children: appRoutes,
  },
]);

export const App = () => <RouterProvider router={router} />;
